import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

export interface MarketSwitchTrackingParams {
    trackingLocation: string;
    marketName?: string;
    marketId: string;
    marketPosition: number;
    marketSwitchSelector: MarketSwitchSelector;
    pageReferringAction?: string;
    positionEvent?: string;
}

export enum MarketSwitchSelector {
    Pill,
    Dropdown,
}

@Injectable({ providedIn: 'root' })
export class GridTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackMarketSwitch(params: MarketSwitchTrackingParams): void {
        const trackingObj = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'market switcher',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sport market',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'switch',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: params.trackingLocation,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: params.marketName,
            [trackingConstants.MARKET_ID]: params.marketId,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: params.marketPosition,
            [trackingConstants.COMPONENT_POSITION_EVENT]: params.positionEvent || NOT_APPLICABLE,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };

        if (params.marketSwitchSelector === MarketSwitchSelector.Pill) {
            this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingObj);
        } else {
            this.trackingService.triggerEventWithCleaning(
                trackingConstants.EVENT_FUNC_MARKET_SWITCH,
                Object.assign({ [trackingConstants.PAGE_REFERRING_ACTION]: params.pageReferringAction }, trackingObj),
            );
        }
    }
}
